/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { ApplicationListItemResponse, PageApplicationListItemResponse } from "../../api/types/swagger-api-types"

export enum ApplicationStatus {
    active = "ACTIVE",
    infected = "INFECTED",
    insecure = "INSECURE"
}

/** The flags the API can raise against a device. */
export enum DeviceFlag {
    ADB_ENABLED = "ADB_ENABLED",
    DEVELOPER_MODE = "DEVELOPER_MODE",
    DISABLED_PLAY_PROTECT = "DISABLED_PLAY_PROTECT",
    EMULATOR = "EMULATOR",
    HTTP_PROXY = "HTTP_PROXY",
    JAILBROKEN = "JAILBROKEN",
    NO_BIOMETRY = "NO_BIOMETRY",
    NO_RASP_CONFIG = "NO_RASP_CONFIG",
    NO_SCREEN_LOCK = "NO_SCREEN_LOCK",
    REPACKAGED_SOURCE = "REPACKAGED_SOURCE",
    ROOTED = "ROOTED",
    UNWANTED_APPS = "UNWANTED_APPS"
}

export type PageApplicationId = {
    appTypeId: number
    status: ApplicationStatus
    flags: string[]
    page: number
}

export type PageApplicationList = PageApplicationListItemResponse
export type PageApplicationItem = ApplicationListItemResponse
